import React from 'react';

function getStrength(password) {
  if (!password) return { score: 0, label: '', color: '' };
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 2) return { score: 1, label: 'Weak', color: 'bg-red-500' };
  if (score <= 3) return { score: 2, label: 'Fair', color: 'bg-yellow-500' };
  if (score <= 4) return { score: 3, label: 'Good', color: 'bg-blue-500' };
  return { score: 4, label: 'Strong', color: 'bg-green-500' };
}

export default function PasswordStrength({ password }) {
  const { score, label, color } = getStrength(password);
  if (!password) return null;

  const checks = [
    { met: password.length >= 8, text: '8+ characters' },
    { met: /[A-Z]/.test(password), text: 'Uppercase letter' },
    { met: /[a-z]/.test(password), text: 'Lowercase letter' },
    { met: /[0-9]/.test(password), text: 'Number' },
  ];

  return (
    <div className="mt-2">
      <div className="flex items-center space-x-2 mb-1">
        <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden flex space-x-1">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className={`flex-1 rounded-full transition-colors ${i <= score ? color : 'bg-gray-200'}`} />
          ))}
        </div>
        <span className={`text-xs font-medium ${score <= 1 ? 'text-red-600' : score <= 2 ? 'text-yellow-600' : score <= 3 ? 'text-blue-600' : 'text-green-600'}`}>
          {label}
        </span>
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-0.5">
        {checks.map((c, i) => (
          <span key={i} className={`text-xs ${c.met ? 'text-green-600' : 'text-gray-400'}`}>
            {c.met ? '\u2713' : '\u2022'} {c.text}
          </span>
        ))}
      </div>
    </div>
  );
}
